export default __webpack_public_path__ + "static/stylam-exclusive-d9578969ae08d492dce458a2681a2124.pdf";